module.exports = __webpack_public_path__ + "img/图层 11.c89a1be3.png";